module.exports = __webpack_public_path__ + "img/phone-green.a702de4b.svg";